// extracted by mini-css-extract-plugin
module.exports = {"selectFlight":"selectFlight--3YU9R","spinHolder":"spinHolder--5EKDg"};